import React from 'react'

import { array, string } from 'prop-types'

import TypeList from './Components/TypeList/TypeList'

function TypeSection({ byType, title }) {

  return (
    <div className="assets-3d-categories__column assets-3d-categories__column--type">
      <h4 className="assets-3d-categories__title">{title}</h4>
      <TypeList items={byType} />
    </div>
  )
}

TypeSection.propTypes = {
  byType: array.isRequired,
  title: string.isRequired,
}

export default TypeSection
